module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"h-1":"倉庫スペースを提供したい方へ","lead":"使っていない倉庫スペースを:そのままにしていませんか？:\\nWarexに登録すれば、:遊休スペースを活用して: :新たな収入源にすることが可能です。:"}}')
  delete Component.options._Ctor
}
